export default __webpack_public_path__ + "static/media/29.503d4807.jpg";